import React from "react";
import { DateTimeRangeModal } from "../../../../modals/DateTimeRangeModal";
import { TableCalendarModal } from "../../TableCalendarModal";
import { useSimpleTableContext } from "../../../contexts/SimpleTableContext";
import { useFilterContext } from "@/contexts/FilterContext";
import type { BaseEntity, SimpleTableConfig } from "../../../types";

/**
 * Renders all modals for SimpleTableDesktopView
 * Includes DateTimeRange and Calendar modals
 * Consumes data directly from SimpleTableContext and FilterContext
 */
export function SimpleTableModalsSection<TData extends BaseEntity>() {
  const context = useSimpleTableContext<TData>();
  const filterContext = useFilterContext<TData>();

  const {
    config,
    processedData,
    callbacks,
  } = context;

  const {
    uiState,
  } = filterContext;

  return (
    <>
      {/* Custom DateTime Range Modal */}
      <DateTimeRangeModal
        isOpen={uiState.customRangeModal.isOpen}
        onClose={callbacks.handleCustomRangeClose}
        onApply={(start, end) =>
          callbacks.handleCustomRangeApply(start || new Date(), end || new Date())
        }
        fieldLabel={uiState.customRangeModal.fieldLabel || ""}
      />

      {/* Calendar View Modal */}
      <TableCalendarModal data={processedData} config={config} />
    </>
  );
}
